import { apiORDS, apiORDSpost } from '../shared/api-functions'


const MODULO = 'sales/pedv/'
const MODULODUPLICA = 'sales/pedv/duplica'
const MODULOIT = 'sales/pedvit/'
const MODULOCANCELIT = 'sales/pedvit/cancel/'
const MODULODELETEIT = 'sales/pedvit/delete/'
const MODULOVAREJO = 'sales/pedv/varejo'
const MODULOVAREJOVMOVCAIXA = 'varejo/vmovcaixa/'


export default {

  methods: {

    async apiPedido(operacao, pedv, pedvit, pedvpar, responseCallback) {

      let pedido = pedv
      pedido.pedvit = pedvit
      pedido.pedvpar = pedvpar
      var sendData = { pedv: pedido }

      let metodo = 'post'
      let update = false
      if (this.pedv.codpedv != null) {
        metodo = 'put'
        update = true
      }

      const data = await apiORDSpost(this.$store, MODULO, sendData, metodo)
      if (!data.items) {
        return
      }

      let validation = null
      if (data.items[0].validation) {
        validation = JSON.parse(data.items[0].validation)
      } else if (data.items[0].stpedv == 'C') {
        this.$erpToastWarning('O pedido foi cancelado')
        this.closeForm()
      }

      if (operacao == 'gerarpedido')
        if (data.items[0].tppedv == 'P')
          this.$erpToastSuccess('O orçamento foi transformado em pedido')

      if (operacao == 'perdido')
        this.$erpToastError('Orçamento perdido')

      if (responseCallback) {
        responseCallback(operacao, data.items[0], validation)
      }
    },

    async apiVarejoPedido(pedv, pedvit, pagamentos, cancel, responseCallback) {
      if (cancel) pedv.stpedv = 'C'

      let pedido = pedv
      pedido.pedvit = pedvit
      //pedido.pedvpar = pedvpar
      //pedido.pagamentos = pagamentos
      var sendData = { pedv: pedido }

      let metodo = 'post'

      const data = await apiORDSpost(this.$store, MODULOVAREJO, sendData, metodo)
      if (!data.items) {
        return
      }

      let erros = []
      if (data.items[0].validation) {
        erros = JSON.parse(data.items[0].validation)
        this.$scrollTo(0)
        if (erros.errmessages)
          this.$erpToastError('Por favor corrija os erros de validação')
      } else 
      if (data.items[0].stpedv == 'C') {
        this.$erpToastWarning('O pedido foi cancelado')
        this.closeForm()
      }

      if (responseCallback) {
        responseCallback(data.items[0], erros)
      }
    },

    async apiDuplicaPedido(codpedv, responseCallback) {
      //efetua a copia do pedido
      var sendData = { pedv: codpedv }

      const data = await apiORDSpost(this.$store, MODULODUPLICA, sendData, 'post')
      if (!data.items) {
        return
      }
      if (data.items[0].tppedv === 'P') {
        this.$erpToastSuccess('Pedido copiado. O novo pedido criado é: ' + data.items[0].npedido)
      } else {
        this.$erpToastSuccess('Orçamento copiado. O novo orçamento criado é: ' + data.items[0].ncotacao)
      }
      let errmessages = []
      if (data.items[0].validation) {
        errmessages = JSON.parse(data.items[0].validation)
      }
      if (responseCallback) {
        responseCallback(data.items[0], errmessages)
      }
    },

    async apiItemPedido(senddata, updateItem, cancelItem, deleteItem, responseCallback) {

      let modulo = MODULOIT
      let metodo = 'post'
      if (!senddata.pedv.codpedv) {
        modulo = MODULO
      } else
        if (updateItem) {
          metodo = 'put'
        } else
          if (cancelItem) {
            modulo = MODULOCANCELIT
          } else
            if (deleteItem) {
              modulo = MODULODELETEIT
            }

      const data = await apiORDSpost(this.$store, modulo, senddata, metodo)
      let validation = null
      if (data.items) {
        if (cancelItem)
          this.$erpToastSuccess('O produto foi cancelado com sucesso.')
        else if (updateItem)
          this.$erpToastSuccess('Item alterado com sucesso.')
        else if (senddata.pedv.pedvit.length && senddata.pedv.pedvit.length > 1)
          this.$erpToastSuccess('Os produtos selecionados foram adicionados.')
        else if (senddata.pedv.pedvit.length)
          this.$erpToastSuccess('O produto selecionado foi adicionado.')

        if (data.items[0].validation) {
          validation = JSON.parse(data.items[0].validation)
        }
      }

      if (responseCallback) {
        if (deleteItem) {
          this.$erpToastSuccess('O produto foi excluído do pedido.')
          responseCallback('deleteItem', null, validation)
        }
        else
          responseCallback(null, data.items[0], validation)
      }
    },

    async apiRentab(pedv, liberada, desfazerLiberacao, obs, responseCallback) {

      let dados = {
        codpedv: pedv.codpedv,
        obs: obs,
        liberada: liberada,
        desfazer: desfazerLiberacao

      }

      let url = MODULO + '/' + pedv.codpedv + '/rentabilidade'

      const data = await apiORDSpost(this.$store, url, dados, 'post')

      if (desfazerLiberacao)
        this.$erpToastSuccess('Liberação desfeita.')
      else
        if (liberada)
          this.$erpToastSuccess('Liberação efetuada.')
        else
          this.$erpToastSuccess('Reprovação efetuada.')

      if (responseCallback) {
        responseCallback('rentab')
      }
    },

    async apiVarejoVMovCaixa(paramvmovcaixa, cancel, responseCallback) {
      //if (cancel) pedv.stpedv = 'C'

      let vmcaixa = paramvmovcaixa
      var sendData = { vmovcaixa: vmcaixa }

      let metodo = 'post'
      let modulo = MODULOVAREJOVMOVCAIXA

      modulo = modulo + (vmcaixa.codvmovcaixa != undefined ? vmcaixa.codvmovcaixa : '0');

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      if (data.validation) {
        this.$erpToastError(data.validation)
        if (responseCallback) {
          responseCallback(null, null, data.validation)
        }
        return
      }
      if (!data.items) {
        return
      }

      let errmessages = []
      if (data.items[0].validation) {
        errmessages = JSON.parse(data.items[0].validation)
        this.$scrollTo(0)
        this.$erpToastError('Por favor corrija os erros de validação')
      }

      if (responseCallback) {
        responseCallback(data.items[0], errmessages)
      }
    },

    async apiEnviaPedidoWhats(pedv, numero) {
      //envio do pedido de venda pelo whats
      await this.$store.dispatch('loadPedv', { id: pedv.codpedv })
      let pedido = null
      if (this.$store.getters.getPedv[0])
        pedido = this.$store.getters.getPedv[0]

      let msg = "";
      let link = null
      if (pedido.ecommerce == 'S') {
        if (this.$store.getters.getSessao.dominio) {
          const isHomolog = typeof window !== 'undefined' && window.location && (window.location.host.indexOf('teste') >= 0 || window.location.host.indexOf('localhost') >= 0);
          const sufixo = isHomolog ? '.teste.notabrasil.com.br' : '.notabrasil.com.br';
          link = 'https://' + this.$store.getters.getSessao.dominio + sufixo + '/loja/#/pedido-concluido?uuid=' + pedido.uuid
        }
        msg = 'Um novo status foi vinculado ao seu pedido em nossa loja virtual acesse: ' + link
      }
      else {
        const data = await apiORDS(this.$store.getters.urlOrds + 'sales/linkpdf/' + pedido.codpedv, null)
        if (data.link)
          link = data.link
        if (pedido.part[0].fantasia)
          msg = msg + "Olá *" + pedido.part[0].fantasia + "*,\n"
        if (pedido.filial[0].fantasia)
          msg = msg + "Seu pedido emitido por *" + pedido.filial[0].fantasia + "* está disponível.\n\n";
        msg = msg + "• Link para a impressão do pedido em pdf, *acesse*: \n" + data.link;
      }

      msg = window.encodeURIComponent(msg);

      if (link)
        window.open("https://wa.me/?phone=55" + numero + '&text="' + msg, "_blank")

    },

    async apiGerarNF(tipo) {
      var modulo = "invoice/order/" + this.pedv.codpedv;
      if (tipo)
          modulo += '?especie=' + tipo
      const data = await apiORDSpost(this.$store, modulo, {}, "post");
      if (data.codnf) {
        this.pedv.nf = data.codnf;
        await this.$store.dispatch("loadNf", { id: data.codnf });
        if (this.$store.getters.getNf) {
          this.pedv.nf = { ...this.$store.getters.getNf[0] };
        }
      }
    },

    // async apiEnviarNF(tipo) {
    //   var modulo = "invoice/varejo/" + tipo + "/" + this.pedv.nf.codnf;
    //   const data = await apiORDSpost(this.$store, modulo, {}, "post");
    //   if (data.codnf) {
    //     this.pedv.nf = data;
    //     await this.$store.dispatch("loadNf", { id: data.codnf });
    //     if (this.$store.getters.getNf) {
    //       this.pedv.nf = { ...this.$store.getters.getNf[0] };
    //     }
    //   }
    // },


  }
}





// WEBPACK FOOTER //
// ./src/api/api-pedido.js